<template>
    <div>
        <div class="content-box mr60">
            <el-form ref="form" label-width="120px" :model="formItem" :rules="rules" class="form-wrap">
                <el-form-item label="" prop="type">
                    <el-radio v-model="formItem.type" label="1">按工单，分尺寸下载：<br /><span :style="{lineHeight: '24px', paddingLeft: '24px'}">如：项目名称.zip/项目名称-素材类型-工单ID/尺寸/素材文件</span></el-radio>
                    <div :style="{padding: '5px'}"></div>
                    <el-radio v-model="formItem.type" label="2">按工单下载：<br /><span :style="{lineHeight: '24px', paddingLeft: '24px'}">如：项目名称.zip/项目名称-素材类型-工单ID/素材文件</span></el-radio>
                </el-form-item>
            </el-form>
        </div>
        <p class="dialog-footer tac mt20">
            <el-button type="default" @click="hideModal" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="submitModal" :loading="formLoading" class="action-btn ml20">提交</el-button>
        </p>
    </div>
</template>

<!-- 工单管理 批量下载弹框-->
<script>

import API from '@/api/workOrder/material.js';
import matomoFun from "@/utils/matomo.js";
export default {
    name: "downLoadTaskModal",
    props:['cbs', 'id', 'name', 'desc'],
    data(){
        return {
            formLoading:false,
            formItem:{
                type:'1',
            },
            rules:{
                type: [
                    { required: true, message: '请选择下载方式', trigger: 'blur' },
                ],
            },
        }
    },
    mounted(){
    },
    methods:{
        pushMatomo(name) {
            matomoFun.trackEvent(this.name, '点击', `${this.desc}-${name}`)
        },
        submitModal(){
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.fetchBatchDownLoad(this.id)
                } else {
                    return false;
                }
            });
        },
        hideModal(){
            this.$emit('close');
        },
        //批量下载
        fetchBatchDownLoad(id, order_id) {
            let obj_params = {type: this.formItem.type}
            obj_params['material_id'] = id
            this.formLoading = true
            if(this.formItem.type == '1'){
                this.pushMatomo('按工单分尺寸下载提交)')
            }else{
                this.pushMatomo('按工单下载提交)')
            }
            API.postOrderTaskDownLoad(obj_params).then(res=>{
                this.$message.success(res.info)
                this.cbs.onSubmit()
                this.formLoading = false
            }, err=>{
                this.$message.error(err.info)
            }).finally(()=>{
                this.formLoading = false
            })
        },
    }
}
</script>

<style scoped>

</style>
